import { createContext, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { showNotification } from "Helpers/Toast";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import TwoFactorModal from "Components/Global/Modals/TwoFactor";

export const TwoFactorAuthenticationContext = createContext({
  runTwoFactorAuthentication: () => {},
});

export const TwoFactorAuthenticationProvider = ({ children }) => {
  const { api } = UseServices();
  const { setLoading } = UseGlobalLoading();

  const [shouldShowModal, setShouldShowModal] = useState(false);

  const [callback, setCallback] = useState(null);
  const [routeConfig, setRouteConfig] = useState({});

  const [token, setToken] = useState(null);

  const notify = (message, type) => {
    showNotification(type, "Aviso!", message);
  };

  const runTwoFactorAuthentication = async ({
    route,
    method,
    data,
    cb,
    errorCb,
    token = null,
  }) => {
    try {
      const res = await api[method](route, data, {
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      });

      if (token) setToken(token);

      if (res.data?.two_factor_authentication_required) {
        setShouldShowModal(true);

        if (res.data?.generation_error)
          notify(res.data?.generation_error?.description, "warning");

        setCallback(() => cb);

        setRouteConfig({
          route,
          method,
          data,
        });
      } else {
        cb(res);
      }
    } catch (error) {
      if (errorCb) errorCb(error);
      HTTPErrorCallback(error);
      setLoading(false);
    }
  };

  const validateToken = async (data) => {
    try {
      const res = await api[routeConfig.method](
        routeConfig.route,
        {
          ...routeConfig.data,
          ...data,
        },
        {
          ...(token && { headers: { Authorization: `Bearer ${token}` } }),
        },
      );

      if (res.data?.verification_error)
        return notify(res.data?.verification_error?.description, "danger");

      setShouldShowModal(false);
      callback(res);
    } catch (error) {
      setShouldShowModal(false);
      HTTPErrorCallback(error);
    }
  };

  const contextValue = {
    runTwoFactorAuthentication,
  };

  return (
    <TwoFactorAuthenticationContext.Provider value={contextValue}>
      {shouldShowModal && (
        <TwoFactorModal
          open={shouldShowModal}
          submit={validateToken}
          close={() => setShouldShowModal(false)}
          loading={false}
          setShouldShowModal={setShouldShowModal}
          submitText="Enviar"
          cancelText="Cancelar"
        />
      )}
      {children}
    </TwoFactorAuthenticationContext.Provider>
  );
};
